import React from "react";

const UserSecurityHeaderCard = ({ user }) => {

    return (

        <div className="card shadow-sm mb-3">

            <div className="card-body">

                <div className="row">

                    <div className="col-md-4">

                        <strong>Username</strong>

                        <div>

                            {user.username}

                        </div>

                    </div>

                    <div className="col-md-4">

                        <strong>Email</strong>

                        <div>

                            {user.email}

                        </div>

                    </div>

                    <div className="col-md-4">

                        <strong>Status</strong>

                        <div>

                            <span
                                className={`badge ${
                                    user.is_active
                                        ? "bg-success"
                                        : "bg-danger"
                                }`}
                            >

                                {

                                    user.is_active

                                        ? "Active"

                                        : "Inactive"

                                }

                            </span>

                        </div>

                    </div>

                </div>

                <hr />

                <div className="row">

                    <div className="col-md-3">

                        <strong>Role</strong>

                        <div>

                            {user.role_name}

                        </div>

                    </div>

                    <div className="col-md-3">

                        <strong>Tenant</strong>

                        <div>

                            {user.tenant_name}

                        </div>

                    </div>

                    <div className="col-md-3">

                        <strong>Location</strong>

                        <div>

                            {user.location_name}

                        </div>

                    </div>

                    <div className="col-md-3">

                        <strong>Department</strong>

                        <div>

                            {user.department_name}

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default UserSecurityHeaderCard;